<template>
    <div class="header_wrap">
        <div class="header_tap" v-if="!ismobile">
            <div><img src="@/assets/logo1.png"></div>
            
            <div class="tablist">
                <ul>
                    <li :class="[{active:item.status},{activeClick:item.isActive}]" 
                    v-for="(item,index) in tabList" 
                    :key="index"
                    @mouseenter="enterLi(index)"
                    @mouseleave="leaveLi(index)"
                    @click="handleClick(index)"
                    ><a>{{item.lable}}</a></li>
                </ul>
            </div>
        </div>
        <!-- 移动端导航 -->
        <div v-else>
            <div class="m_tap">
                <div class="m_tap_l" @click="handleIshow">
                    <span :class="{line1:isShow}" ></span>
                    <span :class="{line2:isShow}"></span>
                </div>
                <div>
                    <img src="@/assets/logo2.png" alt="">
                </div>
                <div class="m_tap_right" @click="$router.push('./contact')">
                    <img src="@/assets/icon4.png" alt="">
                </div>
            </div>
            <div class="m_tap_list" :style="ulListStyle">
                <el-collapse-transition >
                    <ul class="m_tap_ul" v-show="isShow" >
                        <li  v-for="(item,index) in tabList"  :key="index" @click="handleClick(index)"> {{item.lable}}</li>
                        
                    </ul>
                </el-collapse-transition>
            </div>
        </div>
    </div>

</template>
<script>
    export default{
        data(){
            return{
                tabList:[
                    {lable:'首页',status:false,isActive:false,route:'/home'},
                    {lable:'关于利真',status:false,isActive:false,route:'/aboutUs'},
                    {lable:'新闻动态',status:false,isActive:false,route:'/news'},
                    {lable:'社会招聘',status:false,isActive:false,route:'/job'},
                    // {lable:'荔枝出行',status:false,isActive:false,route:'/trip'},
                    {lable:'联系我们',status:false,isActive:false,route:'/contact'},
                ],
                bodyWidth:'',
                ismobile:false,
                isShow:false,
                ulListStyle:{
                    height:''
                }
            }
        },
        created(){
            // this.ulListStyle.height = window.screen.height+"px"
        },
        mounted(){
            this.tabList.forEach((item,ix)=>{
                if(this.$route.path == item.route){
                    item.isActive =true
                }
            })
            this.bodyWidth = document.body.clientWidth
            window.onresize = () =>{
                this.bodyWidth = document.body.clientWidth
                
            }
            if(this.bodyWidth<1200){
                    this.ismobile=true
                }else{
                   this.ismobile=false 
                }
           
        },
        methods:{
            enterLi(val){
                this.tabList[val].status=true
            },
            leaveLi(val){
                this.tabList[val].status=false
            },
            handleIshow(){
                this.isShow = !this.isShow
                if(this.isShow){
                    this.ulListStyle.height = window.screen.height+"px"
                }else{
                    this.ulListStyle.height = 0
                }
            },
            handleClick(val){
                this.tabList.map(it =>{if(it.isActive){return it.isActive=!it.isActive}return it})
                
                this.tabList[val].isActive=true
                this.$router.push({path:this.tabList[val].route})
                if(this.ismobile){
                    this.isShow=false
                    this.ulListStyle.height = 0
                }
            }
        }
    }
</script>
<style lang="scss" scope>
*{padding:0;margin:0}
.header_wrap{
    width:100%;
    height:80px;
    position: fixed;
    z-index: 2000;
    text-align: center;
    background: #fff;
    box-shadow: 0 4px 4px 0 rgba(0, 0 ,0 , 0.1);
    .header_tap{
        width:1200px;
        height:100%;
        margin:0 auto;
        display: flex;
        justify-content: space-between;
        img{
            width:120px;
            margin-top:14px;
        }
        .tablist{
            flex: 1;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            li{
                float: left;
                list-style-type: none;
                margin-left:44px;
                font-size: 18px;
                color: #000;
                cursor: pointer;
                position: relative;
                a{
                    text-decoration: none;
                    color: #000;
                }
                a:hover{
                    color: #1F59D6;
                }
            }
            .activeClick{
                color: #1F59D6;
                a{
                  color: #1F59D6;  
                }
            }
            .active:after{
                content: '';
                width:80%;
                height:2px;
                transition: all ease .5s;
                background: #1F59D6;
                bottom: -5px;
                position: absolute;
                border-radius: 4px;
                left: 50%;
                transform: translateX(-50%);
            }
            .activeClick:after{
                content: '';
                width:80%;
                height:2px;
                background: #1F59D6;
                bottom: -5px;
                position: absolute;
                left: 50%;
                border-radius: 4px;
                transition: all ease .5s;
                transform: translateX(-50%);
            }
            
        }
    }
}
@media only screen and (max-width:1200px)  {
    .header_wrap{
        height: 50px;
        background-color: #fff;
        color: #000;
        .m_tap{
            
            position: relative;
            img{
                width: 80px;
                margin-top: 7px;
            }
            .m_tap_right{
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
                img{
                    width: 30px;
                }
            }
            .m_tap_l{
            position: absolute;
            left: 10px;
            top: 50%;
            transform: translateY(-50%);
            span{
                width: 17px ;
                height: 1px;
                background: #000;
                display: block;
                margin: 5px auto;
            }
            .line1{
                transform-origin: 35% 0%;
                animation: line1 0.2s ease-in;
                animation-fill-mode: forwards;
            }
            @keyframes line1 {
                from{
                transform: rotate(0deg);
                }
                to{
                        transform: rotate(45deg);
                    
                }
            }
            .line2{
                animation: line2 0.2s ease-in;
                animation-fill-mode: forwards;
                transform-origin: 15% 0%;
            }
            @keyframes line2 {
                from{
                transform: rotate(0deg);
                }
                to{
                        transform: rotate(-45deg);
                    
                }
            }
        }
        }
        .m_tap_list{
            background-color: #fff;
        }
        .m_tap_ul{
            padding:0 15px;
            text-align: left;
             background-color: #fff;
            //  box-shadow: 0 4px 4px 0 rgba(0, 0 ,0 , 0.1);
            li{
                padding:10px 0;
                border-bottom: 1px solid #ccc;
                list-style: none;
            }
            li:last-child{
                border:0;
                
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/header/header.vue